<template>
  <div class="box">
    <div class="content flex-col">
      <span class="first-title" style="margin-left: 35px;margin-right: 34px;">电脑端微信使用小程序的方法（通用版）</span>
      <span class="second-title">方法一：使用「在电脑上打开」功能</span>
      <span class="describe" style="margin: 5px 25px 11px 25px;">
        确保在电脑上已登录微信，点击小程序右上角【•••】，点击【在电脑上打开】（需要升级至最新版微信）
      </span>
      <img class="outer2" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图4.png'"/>
      <span class="second-title">方法二：打开手机正在浏览的小程序</span>
      <span class="describe">
        保证小程序在手机上是打开的状态，然后登录电脑版微信，点击左下角【手机】按钮，便可打开手机上正在浏览的小程序
      </span>
      <img class="outer3" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图3.png'"/>
      <span class="second-title">Windows版微信使用小程序的方法</span>
      <span class="word4">通过小程序面板打开小程序（仅支持Windows版）</span>
      <span class="describe">
        登录Windows版微信，点击左下角【小程序】图标，打开小程序，即可打开已添加或者已使用过的小程序
      </span>
      <img class="img2" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图2.png'"/>
      <span class="word4">将淘基因添加至「我的小程序」，后续访问更快捷</span>
      <span class="describe">点击小程序右上角【•••】，点击【添加的我的小程序】</span>
      <img class="outer2" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图1.png'"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ComputerSideUsage'
  }
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background-color: #fafafa;
  }

  .content {
    width: 100%;
    height: 1850px;
  }

  .first-title {
    width: 90%;
    height: 24px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 17px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 24px;
    text-align: center;
    align-self: center;
    margin-top: 25px;
  }

  .second-title {
    width: 64%;
    height: 21px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 15px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 21px;
    text-align: left;
    align-self: flex-start;
    margin: 25px 0 0 25px;
  }

  .describe {
    width: 87%;
    height: 42px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 13px;
    line-height: 21px;
    text-align: justify;
    align-self: center;
    margin-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .outer2 {
    position: relative;
    width: 87%;
    height: 342px;
    overflow: hidden;
    align-self: center;
  }

  .outer3 {
    width: 87%;
    height: 233px;
    align-self: center;
    margin-top: 10px;
  }

  .word4 {
    width: 90%;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 15px;
    font-family: PingFangSC-Medium;
    line-height: 21px;
    text-align: left;
    align-self: flex-end;
    margin: 25px 15px 0 0;
  }

  .img2 {
    width: 87%;
    height: 325px;
    align-self: center;
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// ComputerSideUsage.vue?474b60cc